import { useApollo } from "@/common/hooks/useApollo";
import { useSearchTracking } from "@/common/hooks/useSearchTracking";
import { useChatMessageSubscriptions } from "@/common/hooks/useChatMessageSubscriptions";

export function useRouter() {
  useApollo();
  useSearchTracking();
  useChatMessageSubscriptions();
}
